import axios from "axios";
import { config } from "../config";
import authHeader from "./auth-header";
import AuthService from "./auth.service";

class PortalService {
  getService(hash) {
    return axios
      .get(`${config["apiUrl"]}portal/service/${hash}`)
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
      })
      .catch((error) => {
        if (error.response.status == 401) {
          error;
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  storeServiceDocuments(hash, data) {
    return axios
      .post(`${config["apiUrl"]}portal/service/${hash}`, data)
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
      })
      .catch((error) => {
        if (error.response.status == 401) {
          error;
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getEncodedHash(value) {
    return axios
      .get(`${config["apiUrl"]}portal/request-encode-hash/${value}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data.encoded_hash;
        }
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  sendResponseAcceptanceDossierOffer(data) {
    return axios
      .post(`${config["apiUrl"]}portal/dossier/accept-commercial-offer`,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return Promise.reject(error);
      });
  }

  validateDossierOfferHash(hash) {
    return axios
      .post(`${config["apiUrl"]}portal/dossier/validate-hash`, { hash })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return Promise.reject(error);
      });
  }

  downloadDossierOfferReport(hash) {
    return axios
      .get(`${config["apiUrl"]}portal/dossier/download-report/${hash}`, {
        responseType: "blob"
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }
}

export default new PortalService();